'use client';

import Image from 'next/image';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { BetSlipPopout } from './BetSlipPopout';

type MainTab = 'all_bets' | 'jackpot' | 'high_rollers';
type JackpotSubTab =
  | 'Betting Rank Jackpot (Daily)'
  | 'Live Casino Battle (Weekly)'
  | 'Sport Glory Battle (Weekly)'
  | 'Weekly Points Tournament'
  | 'Bonus Crazy Drop';

const JACKPOT_PLAYERS = [
  {
    rank: 1,
    name: 'Wakanda',
    bets: '5000.00',
    bonus: 'MYR600.00',
    pct: '15.00%',
    avatar: '/jackpot/FullTablePeople/people1.png',
    rankFrame: '/jackpot/rank-frame-1.png',
  },
  {
    rank: 2,
    name: 'Mystery Man',
    bets: '4000.00',
    bonus: 'MYR 260.00',
    pct: '6.50%',
    avatar: '/jackpot/FullTablePeople/people2.png',
    rankFrame: '/jackpot/rank-frame-2.png',
  },
  {
    rank: 3,
    name: 'John 67',
    bets: '3000.00',
    bonus: 'MYR 102.00',
    pct: '3.40%',
    avatar: '/jackpot/FullTablePeople/people3.png',
    rankFrame: '/jackpot/rank-frame-3.png',
  },
  {
    rank: 4,
    name: 'Hunter9',
    bets: '2751.56',
    bonus: 'MYR 77.04',
    pct: '2.80%',
    avatar: '/jackpot/FullTablePeople/people4.png',
    rankFrame: null,
  },
  {
    rank: 5,
    name: 'AlphaStrike21',
    bets: '2337.58',
    bonus: 'MYR 58.44',
    pct: '2.50%',
    avatar: '/jackpot/FullTablePeople/people5.png',
    rankFrame: null,
  },
  {
    rank: 6,
    name: 'NightFalcon08',
    bets: '1116.57',
    bonus: 'MYR 23.45',
    pct: '2.10%',
    avatar: '/jackpot/FullTablePeople/people6.png',
    rankFrame: null,
  },
  {
    rank: 7,
    name: 'DarkBlazer99',
    bets: '8.61',
    bonus: 'MYR0.01',
    pct: '0.10%',
    avatar: '/jackpot/FullTablePeople/people7.png',
    rankFrame: null,
  },
  {
    rank: 8,
    name: 'KingKong123',
    bets: '8.50',
    bonus: 'MYR 0.01',
    pct: '0.08%',
    avatar: '/jackpot/FullTablePeople/people8.png',
    rankFrame: null,
  },
];

const _TOP3_GRADIENTS = [
  'linear-gradient(135deg, #801AAD 0%, #4C1D80 50%, #8D46A3 100%)',
  'linear-gradient(135deg, #6B1B9A 0%, #3E0F70 50%, #7B3B99 100%)',
  'linear-gradient(135deg, #5E1187 0%, #3A0D65 50%, #6A2FA0 100%)',
];

const CRAZY_DROP_DATA = [
  {
    time: '04/01/2026 22:12',
    name: 'Nova88',
    bonus: 'MYR 69.11',
    avatar: '/jackpot/FullTablePeople/people1.png',
  },
  {
    time: '04/01/2026 20:23',
    name: 'Drift99',
    bonus: 'MYR 73.12',
    avatar: '/jackpot/FullTablePeople/people2.png',
  },
  {
    time: '04/01/2026 18:33',
    name: 'Phantom66',
    bonus: 'MYR 42.93',
    avatar: '/jackpot/FullTablePeople/people3.png',
  },
  {
    time: '04/01/2026 16:17',
    name: 'Specter335',
    bonus: 'MYR 30.34',
    avatar: '/jackpot/FullTablePeople/people4.png',
  },
  {
    time: '04/01/2026 12:02',
    name: 'Nov6611',
    bonus: 'MYR 29.01',
    avatar: '/jackpot/FullTablePeople/people5.png',
  },
  {
    time: '04/01/2026 09:45',
    name: 'Blaze96',
    bonus: 'MYR 17.89',
    avatar: '/jackpot/FullTablePeople/people6.png',
  },
  {
    time: '04/01/2026 06:51',
    name: 'Flux888',
    bonus: 'MYR 13.21',
    avatar: '/jackpot/FullTablePeople/people7.png',
  },
  {
    time: '04/01/2026 04:22',
    name: 'TitanAce999',
    bonus: 'MYR 10.26',
    avatar: '/jackpot/FullTablePeople/people8.png',
  },
];

const HIGH_ROLLERS_DATA = [
  {
    game: 'Mega Slots',
    payout: 'MYR 5236.91',
    positive: true,
    flag: '/deposite/CountryFlags/MYR.png',
  },
  {
    game: 'Mahjong World',
    payout: '- MYR 7895.43',
    positive: false,
    flag: '/deposite/CountryFlags/MYR.png',
  },
  {
    game: 'Wild Slot',
    payout: '-SGD 2221.01',
    positive: false,
    flag: '/deposite/CountryFlags/SGD.png',
  },
  {
    game: 'Fishing Club',
    payout: 'MYR 88.03',
    positive: true,
    flag: '/deposite/CountryFlags/MYR.png',
  },
  {
    game: 'Dragon Fortune',
    payout: 'MYR 9349.79',
    positive: true,
    flag: '/deposite/CountryFlags/MYR.png',
  },
  {
    game: 'Mystic Gold Slot',
    payout: 'MYR 21510.58',
    positive: true,
    flag: '/deposite/CountryFlags/MYR.png',
  },
  {
    game: 'Treasure Hunt',
    payout: 'MYR 6767.09',
    positive: true,
    flag: '/deposite/CountryFlags/MYR.png',
  },
  {
    game: 'Mahjong World',
    payout: 'MYR 5.35',
    positive: true,
    flag: '/deposite/CountryFlags/MYR.png',
  },
  {
    game: 'Diamond Rush',
    payout: '-MYR 2711.11',
    positive: false,
    flag: '/deposite/CountryFlags/MYR.png',
  },
  {
    game: 'Lucky Spin',
    payout: '-MYR 2548.09',
    positive: false,
    flag: '/deposite/CountryFlags/MYR.png',
  },
];

const ALL_BETS_DATA = [
  {
    game: 'Dragon Fortune',
    payout: 'MYR 7,860.00',
    positive: true,
    flag: '/deposite/CountryFlags/MYR.png',
  },
  {
    game: 'Lucky Spin',
    payout: 'MYR 6222.43',
    positive: true,
    flag: '/deposite/CountryFlags/MYR.png',
  },
  {
    game: 'Lucky Spin',
    payout: '- MYR 5000.01',
    positive: false,
    flag: '/deposite/CountryFlags/MYR.png',
  },
  {
    game: 'Diamond Rush',
    payout: '- MYR 88.03',
    positive: false,
    flag: '/deposite/CountryFlags/MYR.png',
  },
  {
    game: 'Treasure Hunt',
    payout: '- SGD 99.21',
    positive: false,
    flag: '/deposite/CountryFlags/SGD.png',
  },
  {
    game: 'Treasure Hunt',
    payout: '- SGD 110.78',
    positive: false,
    flag: '/deposite/CountryFlags/SGD.png',
  },
  {
    game: 'Mahjong World',
    payout: '- MYR 6767.09',
    positive: false,
    flag: '/deposite/CountryFlags/MYR.png',
  },
  {
    game: 'Mahjong World',
    payout: '- MYR 83.52',
    positive: false,
    flag: '/deposite/CountryFlags/MYR.png',
  },
  {
    game: 'Mystic Gold Slot',
    payout: 'MYR 2245.90',
    positive: true,
    flag: '/deposite/CountryFlags/MYR.png',
  },
  {
    game: 'Dragon Fortune',
    payout: '- MYR 49.16',
    positive: false,
    flag: '/deposite/CountryFlags/MYR.png',
  },
];

const JACKPOT_SUB_TABS: JackpotSubTab[] = [
  'Betting Rank Jackpot (Daily)',
  'Live Casino Battle (Weekly)',
  'Sport Glory Battle (Weekly)',
  'Weekly Points Tournament',
  'Bonus Crazy Drop',
];

function getRankBadge(rank: number) {
  if (rank === 1) {
    return (
      <Image
        src={'/jackpot/Rank1.png'}
        alt={`rank-1`}
        width={45}
        height={45}
        className="w-[40px] h-[40px] object-contain"
      />
    );
  }
  if (rank === 2) {
    return (
      <Image
        src={'/jackpot/Rank 2.png'}
        alt={`rank-2`}
        width={45}
        height={45}
        className="w-[40px] h-[40px] object-contain"
      />
    );
  }
  if (rank === 3) {
    return (
      <Image
        src={'/jackpot/Rank3.png'}
        alt={`rank-3`}
        width={45}
        height={45}
        className="w-[40px] h-[40px] object-contain"
      />
    );
  }
}

export const Leaderboards = () => {
  const t = useTranslations();
  const [mainTab, setMainTab] = useState<MainTab>('jackpot');
  const [jackpotSubTab, setJackpotSubTab] = useState<JackpotSubTab>(
    'Betting Rank Jackpot (Daily)'
  );
  const [isPopoutOpen, setIsPopoutOpen] = useState(false);

  const isCrazyDrop = jackpotSubTab === 'Bonus Crazy Drop';

  const MAIN_TABS: { key: MainTab; label: string }[] = [
    { key: 'all_bets', label: t('ui.leaderboard.all_bets') },
    { key: 'jackpot', label: t('ui.leaderboard.jackpot') },
    { key: 'high_rollers', label: t('ui.leaderboard.high_rollers') },
  ];

  return (
    <div className="flex flex-col p-2">
      <div
        className="flex flex-col rounded-sm border overflow-hidden"
        style={{
          backgroundColor: '#0a0820',
          borderColor: '#7411B2',
          borderWidth: 2,
        }}
      >
        {/* Main tabs */}
        <div className="flex p-2">
          {MAIN_TABS.map(({ key, label }, i) => {
            const isActive = mainTab === key;
            return (
              <button
                key={key}
                type="button"
                onClick={() => setMainTab(key)}
                className="flex flex-1 items-center justify-center px-2 py-2 text-sm font-medium transition-colors border border-[#7411B2]"
                style={{
                  backgroundColor: isActive ? '#301552' : '#4A3563',
                  color: isActive ? '#FFFFFF' : '#B0AFC2',
                  borderTopLeftRadius: i === 0 ? 6 : 0,
                  borderBottomLeftRadius: i === 0 ? 6 : 0,
                  borderTopRightRadius: i === 2 ? 6 : 0,
                  borderBottomRightRadius: i === 2 ? 6 : 0,
                }}
              >
                {label}
              </button>
            );
          })}
        </div>

        {/* Jackpot sub-tabs scrollable row */}
        {mainTab === 'jackpot' && (
          <div
            className="flex overflow-x-auto gap-x-1 px-3 py-2"
            style={{ backgroundColor: '#472258', scrollbarWidth: 'none' }}
          >
            {JACKPOT_SUB_TABS.map(label => {
              const isActive = jackpotSubTab === label;
              return (
                <button
                  key={label}
                  type="button"
                  onClick={() => setJackpotSubTab(label)}
                  className="rounded-full shrink-0 px-3 py-1 text-xs font-medium transition-colors whitespace-nowrap border"
                  style={{
                    backgroundColor: isActive ? '#2D1255' : 'transparent',
                    color: isActive ? '#FFFFFF' : '#8E8AA0',
                    borderColor: isActive ? '#7411B2' : 'transparent',
                  }}
                >
                  {label}
                </button>
              );
            })}
          </div>
        )}

        {/* Content area */}
        <div className="py-3 px-2">
          {/* Jackpot – regular leaderboard */}
          {mainTab === 'jackpot' && !isCrazyDrop && (
            <>
              <div className="grid grid-cols-[1fr_80px_80px] px-1 pb-2">
                <span className="text-[10px] text-gray-400">Rank</span>
                <span className="text-[10px] text-gray-400 text-center">
                  Bets
                </span>
                <span className="text-[10px] text-gray-400 text-right">
                  Bonus
                </span>
              </div>
              <div className="flex flex-col gap-1">
                {JACKPOT_PLAYERS.map(player => {
                  const isTop3 = player.rank <= 3;
                  return (
                    <button
                      key={player.rank}
                      type="button"
                      className="w-full cursor-pointer hover:brightness-110 transition-all rounded-lg  text-left"
                    >
                      <div
                        className="grid grid-cols-[1fr_80px_80px] rounded-sm items-center gap-1 px-1 py-1"
                        style={{
                          background: isTop3
                            ? 'linear-gradient(270deg, #801AAD 0%, #711BA0 3%, #601C92 9%, #551D87 15%, #4E1D82 25%, #4C1D80 50%, #4F1F81 67%, #572486 77%, #662E8E 86%, #7B3B99 94%)'
                            : '#472258',
                        }}
                      >
                        {/* Rank indicator + Avatar + Name */}
                        <div className="flex items-center gap-2 min-w-0">
                          {isTop3 && player.rankFrame ? (
                            <div className="flex items-center gap-0 shrink-0">
                              <div className="-ml-4">
                                {getRankBadge(Number(player.rank))}
                              </div>
                              <Image
                                src={player.avatar}
                                alt={player.name}
                                width={26}
                                height={26}
                                className="rounded-full object-cover"
                              />
                            </div>
                          ) : (
                            <div className="flex items-center gap-1.5 shrink-0">
                              <span className="text-sm font-bold text-white w-4 text-center">
                                {player.rank}
                              </span>
                              <Image
                                src={player.avatar}
                                alt={player.name}
                                width={30}
                                height={30}
                                className="rounded-full object-cover"
                              />
                            </div>
                          )}
                          <span className="text-xs text-white font-medium truncate">
                            {player.name}
                          </span>
                        </div>

                        {/* Bets */}
                        <div className="flex items-center  gap-1 px-2 w-fit py-0.5 rounded-full bg-white/10">
                          <Image
                            src="/icons/bonus-icon.png"
                            alt="coin"
                            width={14}
                            height={14}
                            className="shrink-0"
                          />
                          <span className="text-[11px] text-white">
                            {player.bets}
                          </span>
                        </div>

                        {/* Bonus */}
                        <div className="flex flex-col items-end">
                          <span className="text-xs font-bold text-white whitespace-nowrap leading-tight">
                            {player.bonus}
                          </span>
                          <span className="text-[8px] bg-[#090321]/50 rounded-full px-1.5 py-px text-white whitespace-nowrap mt-0.5">
                            {player.pct}
                          </span>
                        </div>
                      </div>
                    </button>
                  );
                })}
              </div>
            </>
          )}

          {/* Jackpot – Bonus Crazy Drop */}
          {mainTab === 'jackpot' && isCrazyDrop && (
            <>
              <div className="grid grid-cols-[100px_1fr_auto] px-2 pb-2 gap-2">
                <span className="text-[10px] text-gray-400">Time</span>
                <span className="text-[10px] text-gray-400">Name</span>
                <span className="text-[10px] text-gray-400">Bonus</span>
              </div>
              <div className="flex flex-col gap-1">
                {CRAZY_DROP_DATA.map((item, idx) => (
                  <div
                    key={`${item.time}-${item.name}`}
                    className="grid grid-cols-[100px_1fr_auto] items-center gap-2 px-2 py-2 rounded-sm"
                    style={{
                      background:
                        idx <= 2
                          ? 'linear-gradient(270deg, #801AAD 0%, #711BA0 3%, #601C92 9%, #551D87 15%, #4E1D82 25%, #4C1D80 50%, #4F1F81 67%, #572486 77%, #662E8E 86%, #7B3B99 94%)'
                          : '#472258',
                    }}
                  >
                    <span className="text-[10px] text-purple-200 leading-tight">
                      {item.time}
                    </span>
                    <div className="flex items-center gap-2 min-w-0">
                      <Image
                        src={item.avatar}
                        alt={item.name}
                        width={28}
                        height={28}
                        className="rounded-full object-cover shrink-0"
                      />
                      <span className="text-sm text-white truncate">
                        {item.name}
                      </span>
                    </div>
                    <span className="text-sm font-bold text-white whitespace-nowrap">
                      {item.bonus}
                    </span>
                  </div>
                ))}
              </div>
            </>
          )}

          {/* High Rollers */}
          {mainTab === 'high_rollers' && (
            <>
              <div className="grid grid-cols-[1fr_auto] px-3 pb-2 gap-2">
                <span className="text-[10px] text-gray-400">Game</span>
                <span className="text-[10px] text-gray-400">Payout</span>
              </div>
              <div className="flex flex-col gap-1">
                {HIGH_ROLLERS_DATA.map((item, idx) => (
                  <div
                    // biome-ignore lint/suspicious/noArrayIndexKey: mock leaderboards
                    key={`hr-${item.game}-${idx}`}
                    className="grid grid-cols-[1fr_auto] items-center gap-2 px-3 py-3 rounded-sm"
                    style={{
                      backgroundColor: idx % 2 === 0 ? '#472258' : '#47225880',
                    }}
                  >
                    <span className="text-sm text-white">{item.game}</span>
                    <div className="flex items-center gap-1">
                      <span
                        className="text-sm font-bold whitespace-nowrap"
                        style={{ color: item.positive ? '#4CAF50' : '#F44336' }}
                      >
                        {item.payout}
                      </span>
                      <Image
                        src={item.flag}
                        alt={`${item.flag}-country`}
                        width={20}
                        height={10}
                        className="w-[20px] h-[10px] object-contain"
                      />
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}

          {/* All Bets */}
          {mainTab === 'all_bets' && (
            <>
              <div className="grid grid-cols-[1fr_auto] px-3 pb-2 gap-2">
                <span className="text-[10px] text-gray-400">Game</span>
                <span className="text-[10px] text-gray-400">Payout</span>
              </div>
              <div className="flex flex-col gap-1">
                {ALL_BETS_DATA.map((item, idx) => (
                  <button
                    type="button"
                    onClick={() => setIsPopoutOpen(true)}
                    // biome-ignore lint/suspicious/noArrayIndexKey: mock leaderboards
                    key={`ab-${item.game}-${idx}`}
                    className="grid grid-cols-[1fr_auto] items-center gap-2 px-3 py-3 rounded-sm"
                    style={{
                      backgroundColor: idx % 2 === 0 ? '#472258' : '#47225880',
                    }}
                  >
                    <span className="text-sm text-white text-left ">
                      {item.game}
                    </span>
                    <div className="flex items-center gap-1">
                      <span
                        className="text-sm font-bold whitespace-nowrap"
                        style={{ color: item.positive ? '#4CAF50' : '#F44336' }}
                      >
                        {item.payout}
                      </span>
                      <Image
                        src={item.flag}
                        alt={`${item.flag}-country`}
                        width={20}
                        height={10}
                        className="w-[20px] h-[10px] object-contain"
                      />
                    </div>
                  </button>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
      <BetSlipPopout
        isOpen={isPopoutOpen}
        onClose={() => setIsPopoutOpen(false)}
      />
    </div>
  );
};
